import { useMutation } from "@tanstack/react-query";
import { AuthRepositoryImpl } from "../../data/repository/auth_repository_impl";
import { AxiosError } from "axios";
import { useState } from "react";

export const useSendVerificationEmail = () => {
    const authRepository = new AuthRepositoryImpl();
    const [timer, setTimer] = useState<number | null>(null);

    const mutation = useMutation<void, AxiosError, string>({
        mutationFn: (email) => authRepository.sendVerificationEmail(email),
        onSuccess: () => {
            const timerId = setTimeout(() => {
                setTimer(null);
            }, 60000);
            setTimer(timerId);
        }
    });

    return {
        ...mutation,
        timer,
    };
};
